module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', [_c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientType.name),
      expression: "clientType.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.clientType.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.clientType, "name", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Group"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientType.type),
      expression: "clientType.type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.clientType, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("PRIVATE")]), _c('option', [_vm._v("BUSINESS")]), _c('option', [_vm._v("MAINTENANCE")])])])])]), _c('div', {
    staticClass: "row columns text-center"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save Client Type")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-397b47ee!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/CreateClientTypeButtonModal.vue
// module id = 2413
// module chunks = 1